import {
    PARTNER_CURATED_LISTS,
    PARTNER_BONIAL_FR,
    PARTNER_KAUFDA_DE,
    PARTNER_A_BEAUTIFUL_PLATE,
    PARTNER_ADD_A_PINCH,
    PARTNER_ASHLEE_MARIE,
    PARTNER_ASIAN_CAUCASIAN,
    PARTNER_EAT_WHAT_TONIGHT,
    PARTNER_FEASTING_AT_HOME,
    PARTNER_FOOD_FAITH_FITNESS,
    PARTNER_I_AM_A_FOOD_BLOG,
    PARTNER_KEVIN_IS_COOKING,
    PARTNER_LIFE_LOVE_AND_SUGAR,
    PARTNER_MEXICO_IN_MY_KITCHEN,
    PARTNER_PANNING_THE_GLOBE,
    PARTNER_PURELLA,
    PARTNER_THE_FULL_HELPING,
    PARTNER_THE_KITCHEN_PAPER,
    PARTNER_FAV_FAMILY_RECIPES,
    PARTNER_750G,
    PARTNER_MARMITON
} from 'constants/partnerIds'


export default {
    [PARTNER_CURATED_LISTS]: {
        deliveryChannel: 'outofmilk',
        market: 'unspecified',
        partner: {
            id: PARTNER_CURATED_LISTS,
            name: PARTNER_CURATED_LISTS,
            integration_type: 'SL_WIDGET_WEB',
            integration_detail: 'CuratedList',
            isBacklinkRequired: false
        },
        modifiers: {
            theme: 'general',
            isShowCopyright: false,
            closeList: 'mobile',
            headerBackground: 'fff',
            containerType: 'fixedRight',
            isSideButton: true,
            sideButtonOffsetMobile: 60,
            zIndex: 2
        }
    },
    [PARTNER_BONIAL_FR]: {
        deliveryChannel: 'dest.bonial',
        market: 'fr',
        partner: {
            id: PARTNER_BONIAL_FR,
            name: PARTNER_BONIAL_FR,
            integration_type: 'SL_WIDGET_WEB',
            integration_detail: 'BrochureViewer',
            isBacklinkRequired: true
        },
        modifiers: {
            theme: 'bonial',
            isShowCopyright: true,
            closeList: 'all',
            headerBackground: 'fff',
            containerType: 'module',
            isSideButton: false
        }
    },
    [PARTNER_KAUFDA_DE]: {
        deliveryChannel: 'dest.kaufda',
        market: 'de',
        partner: {
            id: PARTNER_KAUFDA_DE,
            name: PARTNER_KAUFDA_DE,
            integration_type: 'SL_WIDGET_WEB',
            integration_detail: 'BrochureViewer',
            isBacklinkRequired: true
        },
        modifiers: {
            theme: 'bonial',
            isShowCopyright: true,
            closeList: 'all',
            headerBackground: 'fff',
            containerType: 'module',
            isSideButton: false
        }
    },
    'partnerName': {
        deliveryChannel: 'test.partner',
        market: 'unspecified',
        partner: {
            id: 'partnerName',
            name: 'partnerName',
            integration_type: 'SL_WIDGET_WEB',
            integration_detail: 'PartnerIntegration',
            isBacklinkRequired: false
        },
        modifiers: {
            theme: 'general',
            isShowCopyright: false,
            closeList: 'mobile',
            headerBackground: 'fff',
            containerType: 'fixedRight',
            isSideButton: true
        }
    },
    [PARTNER_A_BEAUTIFUL_PLATE]: {
        deliveryChannel: 'outofmilk',
        market: 'unspecified',
        partner: {
            id: PARTNER_A_BEAUTIFUL_PLATE,
            name: PARTNER_A_BEAUTIFUL_PLATE,
            integration_type: 'SL_WIDGET_WEB',
            integration_detail: 'PartnerIntegration',
            isBacklinkRequired: false
        },
        modifiers: {
            theme: 'general',
            isShowCopyright: true,
            closeList: 'mobile',
            headerBackground: 'fff',
            containerType: 'fixedRight',
            isSideButton: true
        }
    },
    [PARTNER_ADD_A_PINCH]: {
        deliveryChannel: 'outofmilk',
        market: 'unspecified',
        partner: {
            id: PARTNER_ADD_A_PINCH,
            name: PARTNER_ADD_A_PINCH,
            integration_type: 'SL_WIDGET_WEB',
            integration_detail: 'PartnerIntegration',
            isBacklinkRequired: false
        },
        modifiers: {
            theme: 'general',
            isShowCopyright: true,
            closeList: 'mobile',
            headerBackground: 'fff',
            containerType: 'fixedRight',
            isSideButton: true
        }
    },
    [PARTNER_ASHLEE_MARIE]: {
        deliveryChannel: 'outofmilk',
        market: 'unspecified',
        partner: {
            id: PARTNER_ASHLEE_MARIE,
            name: PARTNER_ASHLEE_MARIE,
            integration_type: 'SL_WIDGET_WEB',
            integration_detail: 'PartnerIntegration',
            isBacklinkRequired: false
        },
        modifiers: {
            theme: 'general',
            isShowCopyright: true,
            closeList: 'mobile',
            headerBackground: 'fff',
            containerType: 'fixedRight',
            isSideButton: true
        }
    },
    [PARTNER_ASIAN_CAUCASIAN]: {
        deliveryChannel: 'outofmilk',
        market: 'unspecified',
        partner: {
            id: PARTNER_ASIAN_CAUCASIAN,
            name: PARTNER_ASIAN_CAUCASIAN,
            integration_type: 'SL_WIDGET_WEB',
            integration_detail: 'PartnerIntegration',
            isBacklinkRequired: false
        },
        modifiers: {
            theme: 'general',
            isShowCopyright: true,
            closeList: 'mobile',
            headerBackground: 'fff',
            containerType: 'fixedRight',
            isSideButton: true
        }
    },
    [PARTNER_EAT_WHAT_TONIGHT]: {
        deliveryChannel: 'outofmilk',
        market: 'unspecified',
        partner: {
            id: PARTNER_EAT_WHAT_TONIGHT,
            name: PARTNER_EAT_WHAT_TONIGHT,
            integration_type: 'SL_WIDGET_WEB',
            integration_detail: 'PartnerIntegration',
            isBacklinkRequired: false
        },
        modifiers: {
            theme: 'general',
            isShowCopyright: true,
            closeList: 'mobile',
            headerBackground: 'fff',
            containerType: 'fixedRight',
            isSideButton: true
        }
    },
    [PARTNER_FEASTING_AT_HOME]: {
        deliveryChannel: 'outofmilk',
        market: 'unspecified',
        partner: {
            id: PARTNER_FEASTING_AT_HOME,
            name: PARTNER_FEASTING_AT_HOME,
            integration_type: 'SL_WIDGET_WEB',
            integration_detail: 'PartnerIntegration',
            isBacklinkRequired: false
        },
        modifiers: {
            theme: 'general',
            isShowCopyright: true,
            closeList: 'mobile',
            headerBackground: 'fff',
            containerType: 'fixedRight',
            isSideButton: true
        }
    },
    [PARTNER_FOOD_FAITH_FITNESS]: {
        deliveryChannel: 'outofmilk',
        market: 'unspecified',
        partner: {
            id: PARTNER_FOOD_FAITH_FITNESS,
            name: PARTNER_FOOD_FAITH_FITNESS,
            integration_type: 'SL_WIDGET_WEB',
            integration_detail: 'PartnerIntegration',
            isBacklinkRequired: false
        },
        modifiers: {
            theme: 'general',
            isShowCopyright: true,
            closeList: 'mobile',
            headerBackground: 'fff',
            containerType: 'fixedRight',
            isSideButton: true
        }
    },
    [PARTNER_I_AM_A_FOOD_BLOG]: {
        deliveryChannel: 'outofmilk',
        market: 'unspecified',
        partner: {
            id: PARTNER_I_AM_A_FOOD_BLOG,
            name: PARTNER_I_AM_A_FOOD_BLOG,
            integration_type: 'SL_WIDGET_WEB',
            integration_detail: 'PartnerIntegration',
            isBacklinkRequired: false
        },
        modifiers: {
            theme: 'general',
            isShowCopyright: true,
            closeList: 'mobile',
            headerBackground: 'fff',
            containerType: 'fixedRight',
            isSideButton: true
        }
    },
    [PARTNER_KEVIN_IS_COOKING]: {
        deliveryChannel: 'outofmilk',
        market: 'unspecified',
        partner: {
            id: PARTNER_KEVIN_IS_COOKING,
            name: PARTNER_KEVIN_IS_COOKING,
            integration_type: 'SL_WIDGET_WEB',
            integration_detail: 'PartnerIntegration',
            isBacklinkRequired: false
        },
        modifiers: {
            theme: 'general',
            isShowCopyright: true,
            closeList: 'mobile',
            headerBackground: 'fff',
            containerType: 'fixedRight',
            isSideButton: true
        }
    },
    [PARTNER_LIFE_LOVE_AND_SUGAR]: {
        deliveryChannel: 'outofmilk',
        market: 'unspecified',
        partner: {
            id: PARTNER_LIFE_LOVE_AND_SUGAR,
            name: PARTNER_LIFE_LOVE_AND_SUGAR,
            integration_type: 'SL_WIDGET_WEB',
            integration_detail: 'PartnerIntegration',
            isBacklinkRequired: false
        },
        modifiers: {
            theme: 'general',
            isShowCopyright: true,
            closeList: 'mobile',
            headerBackground: 'fff',
            containerType: 'fixedRight',
            isSideButton: true
        }
    },
    [PARTNER_MEXICO_IN_MY_KITCHEN]: {
        deliveryChannel: 'outofmilk',
        market: 'unspecified',
        partner: {
            id: PARTNER_MEXICO_IN_MY_KITCHEN,
            name: PARTNER_MEXICO_IN_MY_KITCHEN,
            integration_type: 'SL_WIDGET_WEB',
            integration_detail: 'PartnerIntegration',
            isBacklinkRequired: false
        },
        modifiers: {
            theme: 'general',
            isShowCopyright: true,
            closeList: 'mobile',
            headerBackground: 'fff',
            containerType: 'fixedRight',
            isSideButton: true
        }
    },
    [PARTNER_PANNING_THE_GLOBE]: {
        deliveryChannel: 'outofmilk',
        market: 'unspecified',
        partner: {
            id: PARTNER_PANNING_THE_GLOBE,
            name: PARTNER_PANNING_THE_GLOBE,
            integration_type: 'SL_WIDGET_WEB',
            integration_detail: 'PartnerIntegration',
            isBacklinkRequired: false
        },
        modifiers: {
            theme: 'general',
            isShowCopyright: true,
            closeList: 'mobile',
            headerBackground: 'fff',
            containerType: 'fixedRight',
            isSideButton: true
        }
    },
    [PARTNER_PURELLA]: {
        deliveryChannel: 'outofmilk',
        market: 'unspecified',
        partner: {
            id: PARTNER_PURELLA,
            name: PARTNER_PURELLA,
            integration_type: 'SL_WIDGET_WEB',
            integration_detail: 'PartnerIntegration',
            isBacklinkRequired: false
        },
        modifiers: {
            theme: 'general',
            isShowCopyright: true,
            closeList: 'mobile',
            headerBackground: 'fff',
            containerType: 'fixedRight',
            isSideButton: true
        }
    },
    [PARTNER_THE_FULL_HELPING]: {
        deliveryChannel: 'outofmilk',
        market: 'unspecified',
        partner: {
            id: PARTNER_THE_FULL_HELPING,
            name: PARTNER_THE_FULL_HELPING,
            integration_type: 'SL_WIDGET_WEB',
            integration_detail: 'PartnerIntegration',
            isBacklinkRequired: false
        },
        modifiers: {
            theme: 'general',
            isShowCopyright: true,
            closeList: 'mobile',
            headerBackground: 'fff',
            containerType: 'fixedRight',
            isSideButton: true
        }
    },
    [PARTNER_THE_KITCHEN_PAPER]: {
        deliveryChannel: 'outofmilk',
        market: 'unspecified',
        partner: {
            id: PARTNER_THE_KITCHEN_PAPER,
            name: PARTNER_THE_KITCHEN_PAPER,
            integration_type: 'SL_WIDGET_WEB',
            integration_detail: 'PartnerIntegration',
            isBacklinkRequired: false
        },
        modifiers: {
            theme: 'general',
            isShowCopyright: true,
            closeList: 'mobile',
            headerBackground: 'fff',
            containerType: 'fixedRight',
            isSideButton: true
        }
    },
    [PARTNER_FAV_FAMILY_RECIPES]: {
        deliveryChannel: 'outofmilk',
        market: 'unspecified',
        partner: {
            id: PARTNER_FAV_FAMILY_RECIPES,
            name: PARTNER_FAV_FAMILY_RECIPES,
            integration_type: 'SL_WIDGET_WEB',
            integration_detail: 'PartnerIntegration',
            isBacklinkRequired: false
        },
        modifiers: {
            theme: 'general',
            isShowCopyright: true,
            closeList: 'mobile',
            headerBackground: 'fff',
            containerType: 'fixedRight',
            isSideButton: true
        }
    },
    [PARTNER_750G]: {
        deliveryChannel: 'outofmilk',
        market: 'unspecified',
        partner: {
            id: PARTNER_750G,
            name: PARTNER_750G,
            integration_type: 'SL_WIDGET_WEB',
            integration_detail: 'PartnerIntegration',
            isBacklinkRequired: false
        },
        modifiers: {
            theme: '750G',
            isShowCopyright: true,
            closeList: 'mobile',
            headerBackground: 'fff',
            containerType: 'fixedRight',
            isSideButton: true
        }
    },
    [PARTNER_MARMITON]: {
        deliveryChannel: 'outofmilk',
        market: 'unspecified',
        partner: {
            id: PARTNER_MARMITON,
            name: PARTNER_MARMITON,
            integration_type: 'SL_WIDGET_WEB',
            integration_detail: 'PartnerIntegration',
            isBacklinkRequired: false
        },
        modifiers: {
            theme: 'Marmiton',
            isShowCopyright: true,
            closeList: 'mobile',
            headerBackground: 'fff',
            containerType: 'fixedRight',
            isSideButton: true
        }
    }
}
